import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import FollowFavourites from '../../Models/FollowFavourites';
import Pagination from "react-js-pagination";
import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
import "bootstrap/scss/bootstrap.scss";
var striptags = require('striptags');
class BuyerFavorites extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert('ログインしてください')
            window.location.href = '/login';
        };
        this.state = {
            _id: false,
            user: '',
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: 5,
            total: [],
            favorites: []
        }
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state.user = logged_user.id;
    };
    componentDidMount() {
        window.scrollTo(0, 0)
        FollowFavourites.getFavourites(this.state.user, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ favorites: res.data.payload })
            }
        })
    }
    handlePageChange(pageNumber) {
        // console.log(pageNumber)
        FollowFavourites.getFavourites(this.state.user, pageNumber).then(res => {
            if (res.data.payload != null) {
                this.setState({ favorites: res.data.payload, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }
    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 100))
            )
        }
    }
    pagination() {
        if (this.state.total >= 5) {
            return (<div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-6 ml-5">
                    <Pagination
                        hideNavigation
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>
                <div className="col-md-2"></div>
            </div>)
        }
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view 
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%", fontSize: '20px' }}>
                                    お気に入り
                                </div>
                                <div style={{ minHeight: "1150px" }}>
                                    <div className="custom_padding_dash">
                                        <div className="row">
                                            {this.state.favorites.map(group =>
                                                <div className="" key={group.id} style={{ height: '', width: '100%' }}>
                                                    <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                                                        <div className="row" >
                                                            <div className="col-md-9 remember_text" style={{ paddingBottom: '10px' }}>
                                                                <div className="row pb-2">
                                                                    <div className="col-8">
                                                                        <Link to={{
                                                                            pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                            state: { id: group.seller_id }
                                                                        }} >
                                                                            {group.first_name}
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-4" style={{ textAlign: 'center' }}>
                                                                        <b>{group.price}</b> 円
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <Link to={{
                                                                        pathname: `/categories-details/${group.id}`,
                                                                        state: { id: group.id }

                                                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                                                        <span style={{ fontSize: "14" }}><b>{group.title}</b></span><br />
                                                                    </Link>
                                                                </div>
                                                                <div>
                                                                    <span className="diff_font" >{group.short_desc}</span>
                                                                </div>
                                                                <div className="product_description" style={{ fontSize: "12" }}>
                                                                    {this.details(group.long_desc)}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div style={{}}>
                                                                    <img style={{ width: "100%", height: "120px", objectFit: 'cover' }} src={group.proimg} alt="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //For Desktop view 
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            お気に入り
                                        </div>
                                        <div style={{ minHeight: "1150px" }}>
                                            <div className="custom_padding_dash pt-0">
                                                <div className="row">
                                                    {this.state.favorites.map(group =>
                                                        <div className="" key={group.id} style={{ height: '', width: '100%' }}>
                                                            <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                                                                <div className="row" >
                                                                    <div className="col-md-9 remember_text" style={{ paddingBottom: '10px' }}>
                                                                        <div>
                                                                            <Link to={{
                                                                                pathname: `/categories-details/${group.id}`,
                                                                                state: { id: group.id }

                                                                            }} style={{ textDecoration: 'none' }} className="category-right">
                                                                                <span style={{ fontSize: "14" }}><b>{group.title}</b></span><br />
                                                                            </Link>
                                                                        </div>
                                                                        <div>
                                                                            <span className="diff_font" >{group.short_desc}</span>
                                                                        </div>
                                                                        <div className="product_description" style={{ fontSize: "12" }}>
                                                                            {this.details(group.long_desc)}
                                                                        </div>
                                                                        <div className=" stars row" style={{ marginLeft: '0px' }}>
                                                                            <div style={{ width: "60%" }}>
                                                                                <Link to={{
                                                                                    pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                                    state: { id: group.seller_id }
                                                                                }} >
                                                                                    {group.first_name}
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div style={{}}>
                                                                            <img style={{ width: "100%", height: "120px", objectFit: 'cover' }} src={group.proimg} alt="" />
                                                                        </div>
                                                                        <br />
                                                                        <div className="" style={{ textAlign: 'center' }}>
                                                                            <b>{group.price}</b> 円
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <br />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { BuyerFavorites }